export default {
    emailConfig: {
        subscribeOrUnsubscribe: ['POST', '/api/v1/email-configs/subscribe-or-unsubscribe-email/{unsubscribeToken}'],
        viewInBrowser: ['GET', '/api/v1/email-configs/view-in-browser/{id}'],
    },
};
